import { Form } from "antd";
import { useEffect, useState } from "react";
import { fetchProducts } from "../utils/fetch";
import SelectedProductsList from "./SelectedProductsList";
import SelectProduct from "./SelectProduct";

const ProductsInformation = ({
  setToken,
  selectedProducts,
  setSelectedProducts,
  onChange,
  increasePrice = 0,
  // Добавляем новый проп, чтобы указать, в каком режиме мы находимся
  isEditMode = false,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [knobs, setKnobs] = useState([]);
  const [doorstep, setDoorstep] = useState([]);
  const [latch, setLatch] = useState([]);
  const [doorPanel, setDoorPanel] = useState([]);

  const [selectProductForm] = Form.useForm();

  useEffect(() => {
    fetchProducts(
      setProducts,
      setIsLoading,
      setToken,
      setKnobs,
      setDoorstep,
      setLatch,
      setDoorPanel
    );
  }, [setToken]);

  const deleteSelectedProduct = (id) => {
    const newList = selectedProducts.filter((_, index) => index !== id);
    setSelectedProducts(newList);
  };

  return (
    <div>
      <h1
        style={{
          marginBottom: 20,
        }}
      >
        Информация о товаре
      </h1>

      <Form
        form={selectProductForm}
        initialValues={{
          selectedProduct: "",
          amount: 1,
        }}
      >
        <SelectProduct
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
          isLoading={isLoading}
          products={products}
          form={selectProductForm}
          knobs={knobs}
          doorstep={doorstep}
          latch={latch}
          doorPanel={doorPanel}
          onChange={onChange}
        />
      </Form>

      <SelectedProductsList
        selectedProducts={selectedProducts}
        setSelectedProducts={setSelectedProducts}
        deleteSelectedProduct={deleteSelectedProduct}
        increasePrice={increasePrice}
        // Список поворотников нужен, чтобы менять механизм у уже добавленной двери
        latch={latch}
        // Передаём признак, разрешён ли режим редактирования
        isEditMode={isEditMode}
      />
    </div>
  );
};

export default ProductsInformation;
